import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BsFillBagCheckFill,
  BsStarFill,
  BsStarHalf,
  BsStar,
} from "react-icons/bs";
import {
  FaShoppingCart,
  FaStar,
  FaRegStar,
  FaStarHalfAlt,
} from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules"; // ✅ import Autoplay
import "swiper/css";
import "swiper/css/pagination";
import ExpandedModal from "../common/mediaGallery/ExpandedModal";
import DetailsPageSwiperWithZoom from "./DetailsPageSwiperWithZoom";
import Icon from "../common/Icon";
import { motion, useAnimation } from "framer-motion";
import { cleanHTML, cleanHTML2, formatString } from "../utils/commonHelper";
import AddToCartButton from "./AddToCartButton";
import GeneralButton from "../common/GeneralButton";
import ReactImageMagnify from "react-image-magnify";
import dummy from "../../assets/images/link2.png";
const DetailsCard = ({ product }) => {
  const [selectedSubId, setSelectedSubId] = useState(null);

  const handleShowModal = (id) => setSelectedSubId(id);
  const handleCloseModal = () => setSelectedSubId(null);
  const handleConfirm = () => setSelectedSubId(null);
  const [added, setAdded] = useState(false);
  const controls = useAnimation();
  const navigate = useNavigate();
  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
  const handleAddToCart = async (e) => {
    e.stopPropagation();
    try {
      await controls.start({
        y: [0, -15, 0],
        scale: [1, 1.2, 0.5],
        opacity: [1, 1, 0],
        transition: { duration: 0.7, ease: "easeInOut" },
      });
      setAdded(true);
    } catch (err) {
      console.error(err);
    }
  };
  let media = [];
  if (product.image) media.push({ image: product.image, title: product.title });
  if (product.images && product.images.length > 0) {
    media.push(
      ...product.images.map((pic) => ({
        image: pic?.image || "",
        title: pic.title,
        video: pic?.video || "",
      }))
    );
  }
  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 !== 0;
    const totalStars = 5;

    return (
      <div className="flex space-x-1">
        {[...Array(fullStars)].map((_, i) => (
          <FaStar key={i} className="text-quaternary" />
        ))}
        {halfStar && <FaStarHalfAlt className="text-quaternary" />}
        {[...Array(totalStars - fullStars - (halfStar ? 1 : 0))].map((_, i) => (
          <FaRegStar key={i} className="text-quaternary" />
        ))}
      </div>
    );
  };
  const [swiperRef, setSwiperRef] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const totalSlides = (product?.image ? 1 : 0) + (product?.images?.length || 0);

  const isOutOfStock = product?.inStock === "0";
  return (
    <div className="grid lg:grid-cols-[2fr_1fr]  1xl:grid-cols-[1fr_450px] gap-10 items-start">
      <div className="w-full rounded-[15px] bg-[#DEE2DD]/40 p-6 md:px-10 lg:px-12 lg:py-10 2.5xl:p-12 overflow-hidden p-6">
        {/* Row 1: Title + Add to Cart */}

        {/* Row 2: Descriptions + Image */}
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          {/* Left: Descriptions */}
          <div className="flex flex-col gap-1  w-full">
            <div className="flex justify-between items-center mb-2 gap-10">
              <h2 className="text-34pt lg:text-36pt leading-tight  ">
                {product.title}
              </h2>
            </div>
            {/* Short Description */}
            {/* {product.shortDescription && (
              <p className="text-secondary text-24pt font-mono leading-relaxed">
                {product.shortDescription}
              </p>
            )} */}

            {/* {product.rating && (
                <div className="flex items-center gap-2">
                  {renderStars(product.rating)}
                  <span className="text-sm text-gray-500">
                    ({product.rating.toFixed(1)})
                  </span>
                </div>
              )} */}
            {/* Stock Badge */}
            <div className="flex flex-row items-center justify-between flex-wrap gap-4 my-2">
              <div className="flex flex-row items-center justify-between flex-wrap gap-6">
                <div className="flex items-baseline gap-3 ">
                  <p className="text-34pt text-orange">
                    {product.salePrice} AED
                  </p>
                  {parseInt(product.price) > parseInt(product.salePrice) && (
                    <p className="text-24pt  text-[#444] line-through">
                      {product.price} AED
                    </p>
                  )}
                </div>
                <div>
                  <span
                    className={`${
                      product.inStock === "1" ? "bg-quaternary" : "bg-secondary"
                    } text-white text-14pt font-medium px-3 py-1 rounded-full`}
                  >
                    {product.inStock === "1" ? "In Stock" : "Out of Stock"}
                  </span>
                </div>
              </div>
              <div className="flex">
                {!isOutOfStock && (
                  <div className="relative">
                    <AddToCartButton
                      isOutOfStock={isOutOfStock}
                      addedToCart={product?.addedToCart || 0}
                      onAdd={handleAddToCart}
                      variant="button"
                      animationType="slideRight"
                      className="1 cursor-pointer hover:text-orange"
                      productId={product._id}
                      customerId={loggedInUser?._id || ""}
                      customerEmail={loggedInUser?.email}
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Product Meta */}
            <div className="space-y-1 text-24pt text-gray-700 ">
              {product.brand && (
                <p className="font-mono">
                  <span className="font-sans">Brand:</span> {product.brand}
                </p>
              )}
              {product.categories && (
              <p className="font-mono">
                <span className="font-sans">Categories:</span>{" "}
                {formatString(`${product.categories.join(", ")}`)}
              </p>)}
              {product.materials && (
              <p className="font-mono">
                <span className="font-sans">Materials:</span>{" "}
                {formatString(`${product.materials.join(", ")}`)}
              </p>)}
            </div>

            {/* Long Description */}
            <div
              className="prose prose-sm mt-4 text-24pt terms-container font-mono "
              dangerouslySetInnerHTML={{
                __html: cleanHTML2(product.description),
              }}
            ></div>

            {/* External Links */}
            <div className="flex flex-col md:flex-row  md:items-end justify-between gap-4">
              <div className="flex gap-3 flex-wrap mt-4 ">
                {product.amazonLink && (
                  <GeneralButton
                    onClick={() => window.open(product.amazonLink, "_blank")}
                    text={"Buy on Amazon"}
                    className="md:text-24pt py-1 px-4"
                    bgColor="#CC9965"
                  />
                )}
                {product.noonLink && (
                  <GeneralButton
                    onClick={() => window.open(product.noonLink, "_blank")}
                    text={"Buy on Noon"}
                    className="md:text-24pt py-1 px-4"
                    bgColor="#CC9965"
                  />
                )}
              </div>
              <div className="flex">
                {/* {!isOutOfStock && (
                  <div className="relative">
                    <AddToCartButton
                      isOutOfStock={isOutOfStock}
                      addedToCart={product?.addedToCart || 0}
                      onAdd={handleAddToCart}
                      variant="button"
                      animationType="slideRight"
                      className="1 cursor-pointer hover:text-orange"
                      productId={product._id}
                      customerId={loggedInUser?._id || ""}
                      customerEmail={loggedInUser?.email}
                    />
                  </div>
                )} */}
              </div>
            </div>
          </div>

          {/* Right: Image */}

          {/* <div className="lg:w-1/3 w-full lg:max-w-[500px] max-h-[500px] bg-gray rounded-xl  flex items-center justify-center">
          <div
            className="flex items-center justify-center border border-gray max-w-[500px] rounded-xl relative"
            onClick={() => handleShowModal(1)}
          >
            <DetailsPageSwiperWithZoom
              images={product.images}
              image={product.image}
              id={product._id}
              className=""
            />
          </div>
        </div> */}
        </div>

        {/* Expanded Image Modal */}
      </div>
      <div className="">
        <div className="flex justify-center ">
          <div className="w-[100%] max-w-[230px] xs:max-w-[300px] md:max-w-[280px] 1xl:max-w-[450px] rounded-2xl relative">
            <div id="imageZoom"></div>
            <Swiper
              onSwiper={setSwiperRef}
              onSlideChange={(s) => setActiveSlide(s.activeIndex)}
              modules={[Pagination, Autoplay]}
              autoHeight
              className="w-full h-full review productImage"
            >
              {/* ✅ Main Product Image */}
              {product?.image && (
                <SwiperSlide
                  key="main"
                  className="cursor-pointer flex items-center justify-center bg-white aspect-[4/3] relative "
                  onClick={() => handleShowModal(product._id)}
                >
                  <ReactImageMagnify
                    {...{
                      smallImage: {
                        alt: product.title,
                        isFluidWidth: true,
                        onError: (event) => (event.target.src = dummy),
                        src:
                          process.env.REACT_APP_BACKEND_URL +
                          "public/" +
                          product.image,
                      },
                      largeImage: {
                        src:
                          process.env.REACT_APP_BACKEND_URL +
                          "public/" +
                          product.image,
                        onError: (event) => (event.target.src = dummy),
                        width: 1200,
                        height: 900,
                      },
                      enlargedImagePosition: "over",
                      enlargedImageContainerDimensions: {
                        width: "120%",
                        height: "120%",
                      },
                      enlargedImagePortalId: "imageZoom",
                    }}
                  />
                </SwiperSlide>
              )}

              {/* ✅ Additional Images */}
              {Array.isArray(product?.images) &&
                product.images.map((img, index) => (
                  <SwiperSlide
                    key={index}
                    className="cursor-pointer flex items-center justify-center bg-white aspect-[4/3] relative "
                    onClick={() => handleShowModal(product._id)}
                  >
                    <ReactImageMagnify
                      {...{
                        smallImage: {
                          alt: product.title,
                          isFluidWidth: true,
                          onError: (event) => (event.target.src = dummy),
                          src:
                            process.env.REACT_APP_BACKEND_URL +
                            "public/" +
                            img.image,
                        },
                        largeImage: {
                          src:
                            process.env.REACT_APP_BACKEND_URL +
                            "public/" +
                            img.image,
                          onError: (event) => (event.target.src = dummy),
                          width: 1200,
                          height: 900,
                        },

                        enlargedImagePosition: "over",
                        enlargedImageContainerDimensions: {
                          width: "120%",
                          height: "120%",
                        },
                        enlargedImagePortalId: "imageZoom",
                      }}
                    />
                  </SwiperSlide>
                ))}
            </Swiper>
            {product?.images?.length > 0 && (
              <div className="flex justify-center flex-wrap gap-2 mt-6">
                {Array.from({ length: totalSlides }).map((_, i) => (
                  <button
                    key={i}
                    onClick={() => swiperRef.slideTo(i)}
                    style={{
                      width: "32px",
                      height: "14px",
                    }}
                    className={`rounded-[7px] transition-all
        ${i === activeSlide ? "bg-black" : "bg-none border border-2"}
      `}
                  ></button>
                ))}
              </div>
            )}
          </div>
        </div>

        {selectedSubId && (
          <ExpandedModal
            isOpen={true}
            onClose={handleCloseModal}
            onConfirm={handleConfirm}
            data={{
              title: product.title,
              pictures: media,
              videos: [],
            }}
            initialIndex={activeSlide}
          />
        )}
      </div>
    </div>
  );
};

export default DetailsCard;
